<script setup lang="ts">
import '@banno/jha-wc/src/jha-badge/jha-badge.js'
import {VsgBadge} from '@jack-henry/jha-vue-components'
import {computed} from 'vue'

const props = defineProps<{
  statusCode: string
}>()

const appearance = computed(() => {
  switch (props.statusCode) {
    case 'OPEN':
      return 'primary'
    default:
    case 'CLOSED':
      return 'neutral'
    case 'EMPLOYEE_REVIEW':
      return 'negative'
  }
})

const text = computed(() => {
  switch (props.statusCode) {
    case 'OPEN':
      return 'Open'
    default:
    case 'CLOSED':
      return 'Closed'
    case 'EMPLOYEE_REVIEW':
      return 'Employee Review'
  }
})
</script>

<template>
  <vsg-badge :appearance>{{ text }}</vsg-badge>
</template>

<style scoped>
.primary {
  --jha-badge-background: var(--jha-color-primary);
}
</style>
